import { Component } from '@angular/core';
import { LoopBackConfig, TurnoApi, Turno } from './shared/lb-sdk/index';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private turnoApi: TurnoApi) {
    LoopBackConfig.setBaseURL(environment.url);
    LoopBackConfig.setApiVersion('api');


  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/app.component.ts